import { cn } from '@/lib/utils';

import NextImage from '@/components/atoms/Image';

import { AwardItem } from '../types';
import { BentoDarkCard } from './BentoDarkCard';

type Props = {
  award: AwardItem;
};

const AwardCard = ({ award }: Props) => {
  return (
    <BentoDarkCard
      roudnessLevel='m'
      padSize='s'
      // fixed figma size — shrink-0 so the row scrolls instead of resizing
      className={cn(
        'flex shrink-0 items-center justify-center',
        // necessary to avoid scrolling fade on full row
        'w-[124px] h-32'
      )}
    >
      <NextImage
        src={award.src}
        alt={award.alt}
        width={80}
        height={96}
        objectFit='contain'
        classNames={{
          container: 'h-24 w-20',
          image: 'h-24 w-20',
        }}
      />
    </BentoDarkCard>
  );
};

export default AwardCard;
